<template>
	<div class="footer" >
		<div class="conentT">
			<div class="content">
				<div class="itemBox itemBox2">
					<div class="title">
						<img class="logo" src="@/assets/logo.png" alt="">
					</div>
					<div class="msg">{{ footerData.about_content }}</div>
				</div>
				<div class="itemBox">
					<div class="title">{{languageData.Y联系我们}}</div>
					<div class="it">
						<div class="t">{{footerData.about_phone}}</div>
					</div>
					<div class="it">
						<div class="t">{{footerData.about_email}}</div>
					</div>
					<div class="it">
						<div class="t">{{footerData.about_address}}</div>
					</div>
				</div>
				<div class="itemBox">
					<div class="title">{{languageData.Y关于我们}}</div>
					<div class="imgBox">
						<div class="ii">
							<img class="i" src="@/assets/i119.png" alt="" srcset="">
							<div class="showCode">
								<img class="img" :src="footerData.about_wxcode" alt="" srcset="">
							</div>
						</div>
						<div class="ii" @click="onOpenUrl(footerData.about_twitterx)">
							<img class="i" src="@/assets/i120.png" alt="" srcset="">
						</div>
						<div class="ii" @click="onOpenUrl(footerData.about_facebook)">
							<img class="i" src="@/assets/i121.png" alt="" srcset="">
						</div>
						<div class="ii">
							<img class="i" src="@/assets/i122.png" alt="" srcset="">
							<div class="showCode">
								<img class="img" :src="footerData.about_tiktok" alt="" srcset="">
							</div>
						</div>
						<div class="ii" @click="onOpenUrl(footerData.about_instag)">
							<img class="i" src="@/assets/i123.png" alt="" srcset="">
						</div>
						<div class="ii" @click="onOpenUrl(footerData.about_youtube)">
							<img class="i" src="@/assets/i124.png" alt="" srcset="">
						</div>
					</div>
				</div>
			</div>
			<div class="company">
				<div v-html="footerData.about_beian"></div>
			</div>
		</div>
		
	</div>
</template>

<script lang="ts">
import { defineComponent,ref,onMounted,onUnmounted,watch } from 'vue';
import {postApi,getApi} from '@/utils/index'
import { useRoute,useRouter } from "vue-router"
export default defineComponent({
	name: 'footerComp',
	props: {
		msg: String,
	},
	setup() {
		const footerData:any = ref([])	
		const seoData:any = ref([])	
		const route = useRoute();
		const router = useRouter()
		const languageData:any = ref([])	
		const onOpenUrl = async (url:any) => {
			window.open(url)
		}
		const getfooter = async () => {
			let res:any = await getApi('/api/index/getfooter',{})
			footerData.value = res.data

			
			
			languageData.value = JSON.parse(localStorage.getItem('languageData') || '')

			let data:any = {
				method: 'index'
			}
			if (route.name == 'panel') {
				data.method = languageData.value.Y钕铁硼
			} else if (route.name == 'panel2') {
				data.method = languageData.value.Y钐钴
			}
			if (route.name == 'productData' || route.name == 'productData2' || route.name == 'productHistory' || route.name == 'Industrial') {
				data.method = route.query.title
			}
			if (route.name == 'IndustrialDataCenter') {
				data.method = route.query.title
			}
			if (route.name == 'chinaOperate' || route.name == 'cutOut' || route.name == 'ImportExport' || route.name == 'next3Years' || route.name == 'operationBox' || route.name == 'regionOperate' || route.name == 'tradingNation') {
				data.method = ''
			}
			if (route.name == 'articleDetails' || route.name == 'articleDetailsd' || route.name == 'IndustrialDetails' || route.name == 'IndustrialDetails2') {
				data.method = ''
			}
			if (route.name == 'companyPanel') {
				data.method = 'companyPanel'
			}

			if (data.method != '') {
				let res2:any = await getApi('/api/index/getseo',data)
				seoData.value = res2.data
				if (data.method) {
					document.title = seoData.value.title
					var keywords:any = document.querySelector('meta[name="keywords"]');
					keywords.setAttribute('content', seoData.value.keywords);
					var description:any = document.querySelector('meta[name="description"]');
					description.setAttribute('content', seoData.value.description);
				}
			}
			
			
		}
		onMounted(() => {
			getfooter()
		})
		watch(route, (newValue, oldValue) => {
			if (newValue){
				getfooter()
			}
			
		})
		return {
			footerData,
			onOpenUrl,
			languageData
		}
	}
});
</script>

<style scoped lang="scss">

.footer{
	background: linear-gradient(321deg,hsla(0,0%,100%,0) 27%,hsla(0,0%,100%,.3) 36%,hsla(0,0%,100%,0) 43%),linear-gradient(169deg,#fff -8%,hsla(0,0%,100%,0) 38%),linear-gradient(180deg,rgba(226,230,235,.8),hsla(0,0%,100%,0) 69%);
	backdrop-filter: blur(10px);
	background-size: 100% 1502px;
	min-width: 1380px;
	margin: auto;
	.conentT{
		padding: 0 8rem;
		margin: auto;
	}
	.content{
		display: flex;
		justify-content: space-between;
		padding: 4.6rem 0 0 0;
		.itemBox{
			margin-right: 4rem;
			&:last-child{
				margin-right: 0;
			}
			.title{
				position: relative;
				font-size: 1.1rem;
				color: #1F1F1F;
				font-weight: 700;
				padding-bottom: .3rem;
				margin-bottom: 1.1rem;
				display: flex;
    			align-items: center;
				height: 2.5rem;
				&::after{
					content: '';
					position: absolute;
					bottom: 0;
					left: 0;
					width: 1.2rem;
					height: .15rem;
					background: #F73100;
				}
				.logo{
					height: 2.5rem;
				}
			}
			.msg{
				font-size: .9rem;
				color: #434343;
				line-height: 1.4rem;
				text-align: left;
			}
			.it{
				display: flex;
				align-items: baseline;
				font-size: .9rem;
				color: #434343;
				margin-bottom: .6rem;
				.l{
					margin-right: 1.5rem;
				}
				.t{
					flex: 1;
					line-height: 1.3rem;
				}
			}
			.imgBox{
				display: flex;
				flex-wrap: wrap;
				width: 8rem;
				.ii{
					width: 1.2rem;
					margin-right: 2rem;
					margin-bottom: 2rem;
					position: relative;
					&:hover{
						.showCode{
							display: block;
						}
					}
					&:nth-child(3n){
						margin-right: 0;
					}
					.i{
						width: 1.2rem;
						height: 1.2rem;
						cursor: pointer;
					}
					.showCode{
						position: absolute;
						top: 1.2rem;
						left: 50%;
						width: 6rem;
						display: none;
						z-index: 9;
						transform: translate(-50%,0);
						.img{
							width: 100%;
							padding-top: .3rem;
						}
					}
				}
			}
		}
		.itemBox2{
			flex: 0 0 45%;
			text-align: justify;
			.title{
				&::after{
					display: none;
				}
			}
		}
	}
	.company{
		font-size: .8rem;
		color: #7E7E7E;
		text-align: center;
		padding: 3.7rem 0 2.5rem 0;
	}
}
</style>
<style>
.company a{
	color: #7E7E7E;
	text-decoration: none;
	margin-left: 1.5rem;
}
</style>
